// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import config from '../../config';
// import { Calendar } from 'primereact/calendar';
// import { Chips } from 'primereact/chips';

// function UpdateBlogDetail() {
//     const { id } = useParams(); // Get the project ID from the URL
//     const navigate = useNavigate();
//     const [blog, setBlog] = useState({
//         title: '',
//         description: '',
//     });
//     const [featuredImage, setFeaturedImage] = useState(null);
//     const [removeImages, setRemoveImages] = useState([]);
//     const fileInputRef = useRef(null);
//     const [newImages, setNewImages] = useState([]);
//     const [error, setError] = useState('');
//     const [successMessage, setSuccessMessage] = useState('');
//     const featuredImageRef = useRef(null);

//     const [centerContent, setCenterContent] = useState([
//         { title: '', description: '' }
//     ]);

//     const handleContentChange = (index, event) => {
//         const newFields = centerContent.map((field, fieldIndex) => {
//             if (index === fieldIndex) {
//                 return { ...field, [event.target.name]: event.target.value };
//             }
//             return field;
//         });
//         setCenterContent(newFields);
//     };

//     const addContentFields = () => {
//         setCenterContent([...centerContent, { title: '', description: '' }]);
//     };

//     const removeContentFields = (index) => {
//         const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
//         setCenterContent(newFields);
//     };

//     useEffect(() => {
//         const fetchBlogDetails = async () => {
//             try {
//                 const response = await axios.get(`${config.BASE_URL}/api/admin/get-blog/${id}`, { withCredentials: true });
//                 setBlog(response?.data);
//                 setCenterContent(response?.data?.centerContent);
//             } catch (err) {
//                 setError('Failed to fetch blog details');
//             }
//         };

//         fetchBlogDetails();
//     }, [id]);

//     const handleRemoveImage = async (imageName) => {
//         try {
//             const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-blog`, {
//                 blogId: blog._id,
//                 imageName
//             }, { withCredentials: true });

//             if (response.status === 200) {
//                 setRemoveImages(prev => [...prev, imageName]);

//                 setBlog(prevBlog => {
//                     const updatedImages = prevBlog.galleryImages.filter(image => image !== imageName);
//                     return {
//                         ...prevBlog,
//                         galleryImages: updatedImages,
//                         featuredImage: prevBlog.featuredImage === imageName ? null : prevBlog.featuredImage,
//                     };
//                 });
//             } else {
//                 console.error('Failed to remove image');
//             }
//         } catch (err) {
//             console.error('Error removing image:', err);
//         }
//     };

//     const handleFeaturedImageChange = (e) => {
//         setFeaturedImage(e.target.files[0]); // Set the featured image
//     };

//     const handleNewImageChange = (e) => {
//         setNewImages(e.target.files); // Set new images to be uploaded
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append('title', blog.title);
//         formData.append('description', blog.description);
//         formData.append('centerContent', JSON.stringify(centerContent));

//         for (const image of newImages) {
//             formData.append('galleryImages', image);
//         }

//         if (featuredImage) {
//             formData.append('featuredImage', featuredImage);
//         }

//         try {
//             const response = await axios.put(`${config.BASE_URL}/api/admin/update-blog/${id}`, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//                 withCredentials: true,
//             });

//             setBlog(response.data.blog);

//             if (featuredImageRef.current) {
//                 featuredImageRef.current.value = '';
//             }

//             setFeaturedImage(null);
//             setSuccessMessage('Blog updated successfully!');
//         } catch (err) {
//             setError('Failed to update blog');
//         }
//     }

//     return (
//         <div className="dashboard update_detail_wrap">
//             <div className="container">
//                 <h1 className="dash_title">Edit Blog</h1>
//                 <div className="back_btn_wrap">
//                     <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//                 </div>
//                 {blog ? (
//                     <form onSubmit={handleFormSubmit} encType="multipart/form-data">
//                         <div className="update_details_wrap">
//                             <div className="form-group">
//                                 <label>Blog Title</label>
//                                 <input
//                                     type="text"
//                                     value={blog.title}
//                                     onChange={(e) => setBlog({ ...blog, title: e.target.value })}
//                                 />
//                             </div>

//                             <div className="form-group textareaField">
//                                 <h2>Description</h2>
//                                 <textarea
//                                     name="description"
//                                     value={blog.description}
//                                     onChange={(e) => setBlog({ ...blog, description: e.target.value })}
//                                     required
//                                 />
//                             </div>

//                             <div className="form-group">
//                                 <div className="detail_banner_wrap">
//                                     <div className="detail_img_grid">

//                                         <div className="upload_item">
//                                             <label>Featured Image</label>
//                                             <input type="file" onChange={handleFeaturedImageChange} ref={featuredImageRef} />
//                                         </div>
//                                         <div className="detail_img_grid">
//                                             {blog.featuredImage ? (
//                                                 <div className="detail_img_item">
//                                                     <div className="banner_img_wrap">
//                                                         <img src={`${config.BASE_URL}${blog.featuredImage}`} alt="Featured" />
//                                                     </div>
//                                                     <button className="remove_btn" type="button" onClick={() => handleRemoveImage(blog.featuredImage)}>Remove</button>
//                                                 </div>
//                                             ) : (
//                                                 <p>No image available.</p>
//                                             )}
//                                         </div>

//                                     </div>

//                                 </div>
//                             </div>

//                             <div className="add_field textareaField repeaterFields">
//                                 <h2><b>Center Content</b></h2>
//                                 {centerContent && centerContent.length > 0 && centerContent.map((field, index) => (
//                                     <div key={index} className="singleReapterFieldContent update">
//                                         <div className="add_field">
//                                             <div className="form-group">
//                                                 <h2>Title</h2>
//                                                 <input
//                                                     name="title"
//                                                     type="text"
//                                                     value={field.title}
//                                                     placeholder="title"
//                                                     onChange={(event) => handleContentChange(index, event)}
//                                                 />
//                                             </div>
//                                         </div>

//                                         <div className="add_field">
//                                             <div className="form-group">
//                                                 <h2>Description</h2>
//                                                 <input
//                                                     name="description"
//                                                     type="text"
//                                                     value={field.description}
//                                                     placeholder="Description"
//                                                     onChange={(event) => handleContentChange(index, event)}
//                                                 />
//                                             </div>
//                                         </div>

//                                         <button type="button" onClick={() => removeContentFields(index)}>
//                                             Remove
//                                         </button>
//                                     </div>
//                                 ))}
//                                 <button type="button" onClick={addContentFields}>Add More</button>
//                             </div>

//                             <div className="form-group">
//                                 <div className="form-group">
//                                     <label>Gallery Images</label>
//                                     <input type="file" multiple onChange={handleNewImageChange} ref={fileInputRef} />
//                                 </div>
//                                 <div className="detail_item_inner gallery_inner">
//                                     <div className="detail_img_grid">
//                                         {blog?.galleryImages && blog.galleryImages.map((image, index) => (
//                                             <div className="detail_image_item" key={index}>
//                                                 <div className="detail_img_item galleryImages">
//                                                     <img src={`${config.BASE_URL}${image}`} alt={`blog ${index}`} />
//                                                 </div>
//                                                 <button className="remove_btn" type="button" onClick={() => handleRemoveImage(image)}>Remove</button>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="update_btn_wrap">
//                                 <button className="update_btn" type="submit">Update Blog</button>
//                             </div>
//                             {successMessage && <p className="success-message">{successMessage}</p>}
//                             {error && <p className="error-message">{error}</p>}
//                         </div>
//                     </form>
//                 ) : (
//                     <h5>Blog not found!</h5>
//                 )}
//             </div>
//         </div>
//     );
// }

// export default UpdateBlogDetail;









// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
// import JoditEditor from 'jodit-react';
// import config from '../../config';
// import { Calendar } from 'primereact/calendar';
// import { Chips } from 'primereact/chips';

// function UpdateBlogDetail() {
//     const { id } = useParams(); // Get the project ID from the URL
//     const navigate = useNavigate();
//     const [blog, setBlog] = useState({
//         title: '',
//         description: '',
//     });
//     const [featuredImage, setFeaturedImage] = useState(null);
//     const [removeImages, setRemoveImages] = useState([]);
//     const fileInputRef = useRef(null);
//     const [newImages, setNewImages] = useState([]);
//     const [error, setError] = useState('');
//     const [successMessage, setSuccessMessage] = useState('');
//     const featuredImageRef = useRef(null);

//     const [centerContent, setCenterContent] = useState([
//         { title: '', description: '' }
//     ]);

//     // Jodit configuration
//     const config_jodit = {
//         readonly: false,
//         height: 300,
//         toolbar: true,
//         spellcheck: true,
//         language: 'en',
//         toolbarButtonSize: 'medium',
//         toolbarAdaptive: false,
//         showCharsCounter: true,
//         showWordsCounter: true,
//         showXPathInStatusbar: false,
//         askBeforePasteHTML: false,
//         askBeforePasteFromWord: false,
//         buttons: [
//             'source', '|',
//             'bold', 'italic', 'underline', '|',
//             'ul', 'ol', '|',
//             'outdent', 'indent', '|',
//             'font', 'fontsize', 'brush', '|',
//             'image', 'link', 'table', '|',
//             'align', 'undo', 'redo', '|',
//             'hr', 'eraser', 'copyformat', '|',
//             'symbol', 'fullsize',
//         ],
//         uploader: {
//             insertImageAsBase64URI: true
//         },
//         removeButtons: ['brush', 'file'],
//         showXPathInStatusbar: false,
//         showCharsCounter: true,
//         showWordsCounter: true,
//         allowTabNavigation: false,
//     };

//     const handleContentChange = (index, field, value) => {
//         const newFields = centerContent.map((content, fieldIndex) => {
//             if (index === fieldIndex) {
//                 return { ...content, [field]: value };
//             }
//             return content;
//         });
//         setCenterContent(newFields);
//     };

//     const handleContentTitleChange = (index, event) => {
//         handleContentChange(index, 'title', event.target.value);
//     };

//     const handleContentDescriptionChange = (index, content) => {
//         handleContentChange(index, 'description', content);
//     };

//     const addContentFields = () => {
//         setCenterContent([...centerContent, { title: '', description: '' }]);
//     };

//     const removeContentFields = (index) => {
//         const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
//         setCenterContent(newFields);
//     };

//     const handleMainDescriptionChange = (content) => {
//         setBlog(prevBlog => ({
//             ...prevBlog,
//             description: content
//         }));
//     };

//     useEffect(() => {
//         const fetchBlogDetails = async () => {
//             try {
//                 const response = await axios.get(`${config.BASE_URL}/api/admin/get-blog/${id}`, { withCredentials: true });
//                 setBlog(response?.data);
//                 setCenterContent(response?.data?.centerContent || [{ title: '', description: '' }]);
//             } catch (err) {
//                 setError('Failed to fetch blog details');
//             }
//         };

//         fetchBlogDetails();
//     }, [id]);

//     const handleRemoveImage = async (imageName) => {
//         try {
//             const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-blog`, {
//                 blogId: blog._id,
//                 imageName
//             }, { withCredentials: true });

//             if (response.status === 200) {
//                 setRemoveImages(prev => [...prev, imageName]);

//                 setBlog(prevBlog => {
//                     const updatedImages = prevBlog.galleryImages.filter(image => image !== imageName);
//                     return {
//                         ...prevBlog,
//                         galleryImages: updatedImages,
//                         featuredImage: prevBlog.featuredImage === imageName ? null : prevBlog.featuredImage,
//                     };
//                 });
//             } else {
//                 console.error('Failed to remove image');
//             }
//         } catch (err) {
//             console.error('Error removing image:', err);
//         }
//     };

//     const handleFeaturedImageChange = (e) => {
//         setFeaturedImage(e.target.files[0]); // Set the featured image
//     };

//     const handleNewImageChange = (e) => {
//         setNewImages(e.target.files); // Set new images to be uploaded
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append('title', blog.title);
//         formData.append('description', blog.description);
//         formData.append('centerContent', JSON.stringify(centerContent));

//         for (const image of newImages) {
//             formData.append('galleryImages', image);
//         }

//         if (featuredImage) {
//             formData.append('featuredImage', featuredImage);
//         }

//         try {
//             const response = await axios.put(`${config.BASE_URL}/api/admin/update-blog/${id}`, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//                 withCredentials: true,
//             });

//             setBlog(response.data.blog);

//             if (featuredImageRef.current) {
//                 featuredImageRef.current.value = '';
//             }

//             setFeaturedImage(null);
//             setSuccessMessage('Blog updated successfully!');
//         } catch (err) {
//             setError('Failed to update blog');
//         }
//     }

//     return (
//         <div className="dashboard update_detail_wrap">
//             <div className="container">
//                 <h1 className="dash_title">Edit Blog</h1>
//                 <div className="back_btn_wrap">
//                     <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//                 </div>
//                 {blog ? (
//                     <form onSubmit={handleFormSubmit} encType="multipart/form-data">
//                         <div className="update_details_wrap">
//                             <div className="form-group">
//                                 <label>Blog Title</label>
//                                 <input
//                                     type="text"
//                                     value={blog.title}
//                                     onChange={(e) => setBlog({ ...blog, title: e.target.value })}
//                                 />
//                             </div>

//                             {/* <div className="form-group textareaField">
//                                 <h2>Description</h2>
//                                 <JoditEditor
//                                     value={blog.description}
//                                     config={config_jodit}
//                                     onBlur={(content) => handleMainDescriptionChange(content)}
//                                     onChange={(content) => {}}
//                                 />
//                             </div> */}

//                             <div className="form-group">
//                                 <div className="detail_banner_wrap">
//                                     <div className="detail_img_grid">

//                                         <div className="upload_item">
//                                             <label>Featured Image</label>
//                                             <input type="file" onChange={handleFeaturedImageChange} ref={featuredImageRef} />
//                                         </div>
//                                         <div className="detail_img_grid">
//                                             {blog.featuredImage ? (
//                                                 <div className="detail_img_item">
//                                                     <div className="banner_img_wrap">
//                                                         <img src={`${config.BASE_URL}${blog.featuredImage}`} alt="Featured" />
//                                                     </div>
//                                                     <button className="remove_btn" type="button" onClick={() => handleRemoveImage(blog.featuredImage)}>Remove</button>
//                                                 </div>
//                                             ) : (
//                                                 <p>No image available.</p>
//                                             )}
//                                         </div>

//                                     </div>

//                                 </div>
//                             </div>

//                             <div className="add_field textareaField repeaterFields">
//                                 {/* <h2><b>Center Content</b></h2> */}
//                                 {centerContent && centerContent.length > 0 && centerContent.map((field, index) => (
//                                     <div key={index} className="singleReapterFieldContent update">
//                                         {/* <div className="add_field">
//                                             <div className="form-group">
//                                                 <h2>Title</h2>
//                                                 <input
//                                                     name="title"
//                                                     type="text"
//                                                     value={field.title}
//                                                     placeholder="Title"
//                                                     onChange={(event) => handleContentTitleChange(index, event)}
//                                                 />
//                                             </div>
//                                         </div> */}

//                                         {/* <div className="add_field"> */}
//                                             <div className="form-group">
//                                                 <h2>Description {index+1}</h2>
//                                                 <JoditEditor
//                                                     value={field.description}
//                                                     config={config_jodit}
//                                                     onBlur={(content) => handleContentDescriptionChange(index, content)}
//                                                     onChange={(content) => {}}
//                                                 />
//                                             </div>
//                                         {/* </div> */}

//                                         <button type="button" onClick={() => removeContentFields(index)}>
//                                             Remove
//                                         </button>
//                                     </div>
//                                 ))}
//                                 <button type="button" onClick={addContentFields}>Add More</button>
//                             </div>

//                             <div className="form-group">
//                                 <div className="form-group">
//                                     <label>Gallery Images</label>
//                                     <input type="file" multiple onChange={handleNewImageChange} ref={fileInputRef} />
//                                 </div>
//                                 <div className="detail_item_inner gallery_inner">
//                                     <div className="detail_img_grid">
//                                         {blog?.galleryImages && blog.galleryImages.map((image, index) => (
//                                             <div className="detail_image_item" key={index}>
//                                                 <div className="detail_img_item galleryImages">
//                                                     <img src={`${config.BASE_URL}${image}`} alt={`blog ${index}`} />
//                                                 </div>
//                                                 <button className="remove_btn" type="button" onClick={() => handleRemoveImage(image)}>Remove</button>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>

//                             <div className="update_btn_wrap">
//                                 <button className="update_btn" type="submit">Update Blog</button>
//                             </div>
//                             {successMessage && <p className="success-message">{successMessage}</p>}
//                             {error && <p className="error-message">{error}</p>}
//                         </div>
//                     </form>
//                 ) : (
//                     <h5>Blog not found!</h5>
//                 )}
//             </div>
//         </div>
//     );
// }

// export default UpdateBlogDetail;










import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import JoditEditor from 'jodit-react';
import config from '../../config';
import { Calendar } from 'primereact/calendar';
import { Chips } from 'primereact/chips';

function UpdateBlogDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [activeLanguage, setActiveLanguage] = useState('en');
    
    // English blog data
    const [blog, setBlog] = useState({
        title: '',
        description: '',
        // slug: '',
        language: 'en'
    });

    // Spanish blog data
    const [spanishData, setSpanishData] = useState({
        title: '',
        description: '',
        // slug: '',
        language: 'es'
    });

    const [featuredImage, setFeaturedImage] = useState(null);
    const [removeImages, setRemoveImages] = useState([]);
    const fileInputRef = useRef(null);
    const [newImages, setNewImages] = useState([]);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const featuredImageRef = useRef(null);

    // English center content
    const [centerContent, setCenterContent] = useState([
        { title: '', description: '' }
    ]);

    // Spanish center content
    const [spanishCenterContent, setSpanishCenterContent] = useState([
        { title: '', description: '' }
    ]);

    // Jodit configuration
    const config_jodit = {
        readonly: false,
        height: 300,
        toolbar: true,
        spellcheck: true,
        language: activeLanguage,
        toolbarButtonSize: 'medium',
        toolbarAdaptive: false,
        showCharsCounter: true,
        showWordsCounter: true,
        showXPathInStatusbar: false,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        buttons: [
            'source', '|',
            'bold', 'italic', 'underline', '|',
            'ul', 'ol', '|',
            'outdent', 'indent', '|',
            'font', 'fontsize', 'brush', '|',
            'image', 'link', 'table', '|',
            'align', 'undo', 'redo', '|',
            'hr', 'eraser', 'copyformat', '|',
            'symbol', 'fullsize',
        ],
        uploader: {
            insertImageAsBase64URI: true
        },
        removeButtons: ['brush', 'file'],
        showXPathInStatusbar: false,
        showCharsCounter: true,
        showWordsCounter: true,
        allowTabNavigation: false,
    };

    // Language switching
    const switchLanguage = (lang) => {
        setActiveLanguage(lang);
    };

    // English content handlers
    const handleContentChange = (index, field, value) => {
        const newFields = centerContent.map((content, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...content, [field]: value };
            }
            return content;
        });
        setCenterContent(newFields);
    };

    const handleContentTitleChange = (index, event) => {
        handleContentChange(index, 'title', event.target.value);
    };

    const handleContentDescriptionChange = (index, content) => {
        handleContentChange(index, 'description', content);
    };

    const addContentFields = () => {
        setCenterContent([...centerContent, { title: '', description: '' }]);
    };

    const removeContentFields = (index) => {
        const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
        setCenterContent(newFields);
    };

    const handleMainDescriptionChange = (content) => {
        setBlog(prevBlog => ({
            ...prevBlog,
            description: content
        }));
    };

    // Spanish content handlers
    const handleSpanishContentChange = (index, field, value) => {
        const newFields = spanishCenterContent.map((content, fieldIndex) => {
            if (index === fieldIndex) {
                return { ...content, [field]: value };
            }
            return content;
        });
        setSpanishCenterContent(newFields);
    };

    const handleSpanishContentTitleChange = (index, event) => {
        handleSpanishContentChange(index, 'title', event.target.value);
    };

    const handleSpanishContentDescriptionChange = (index, content) => {
        handleSpanishContentChange(index, 'description', content);
    };

    const addSpanishContentFields = () => {
        setSpanishCenterContent([...spanishCenterContent, { title: '', description: '' }]);
    };

    const removeSpanishContentFields = (index) => {
        const newFields = spanishCenterContent.filter((field, fieldIndex) => index !== fieldIndex);
        setSpanishCenterContent(newFields);
    };

    const handleSpanishDescriptionChange = (content) => {
        setSpanishData(prevData => ({
            ...prevData,
            description: content
        }));
    };

    // Spanish input handlers
    const handleSpanishInputChange = (e) => {
        const { name, value } = e.target;
        setSpanishData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    // Fetch blog data
    useEffect(() => {
        const fetchBlogDetails = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/get-blog-admin/${id}`, { withCredentials: true });
                const blogData = response?.data;
                
                // Set English data
                setBlog({
                    ...blogData,
                    title: blogData.title || '',
                    description: blogData.description || '',
                    // slug: blogData.slug || ''
                });
                setCenterContent(blogData?.centerContent || [{ title: '', description: '' }]);

                // Set Spanish data
                if (blogData.spanishData) {
                    setSpanishData({
                        title: blogData.spanishData.title || '',
                        description: blogData.spanishData.description || '',
                        // slug: blogData.spanishData.slug || '',
                        language: 'es'
                    });
                    setSpanishCenterContent(blogData.spanishData.centerContent || [{ title: '', description: '' }]);
                }
            } catch (err) {
                setError('Failed to fetch blog details');
            }
        };

        fetchBlogDetails();
    }, [id]);

    const handleRemoveImage = async (imageName) => {
        try {
            const response = await axios.post(`${config.BASE_URL}/api/admin/remove-image-blog`, {
                blogId: blog._id,
                imageName
            }, { withCredentials: true });

            if (response.status === 200) {
                setRemoveImages(prev => [...prev, imageName]);

                setBlog(prevBlog => {
                    const updatedImages = prevBlog.galleryImages.filter(image => image !== imageName);
                    return {
                        ...prevBlog,
                        galleryImages: updatedImages,
                        featuredImage: prevBlog.featuredImage === imageName ? null : prevBlog.featuredImage,
                    };
                });
            } else {
                console.error('Failed to remove image');
            }
        } catch (err) {
            console.error('Error removing image:', err);
        }
    };

    const handleFeaturedImageChange = (e) => {
        setFeaturedImage(e.target.files[0]);
    };

    const handleNewImageChange = (e) => {
        setNewImages(e.target.files);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        
        // English data
        formData.append('title', blog.title);
        formData.append('description', blog.description);
        // formData.append('slug', blog.slug);
        formData.append('language', blog.language);
        formData.append('centerContent', JSON.stringify(centerContent));

        // Spanish data
        const spanishDataWithContent = {
            ...spanishData,
            centerContent: spanishCenterContent
        };
        formData.append('spanishData', JSON.stringify(spanishDataWithContent));

        // File uploads
        for (const image of newImages) {
            formData.append('galleryImages', image);
        }

        if (featuredImage) {
            formData.append('featuredImage', featuredImage);
        }

        try {
            const response = await axios.put(`${config.BASE_URL}/api/admin/update-blog/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            });

            setBlog(response.data.blog);

            if (featuredImageRef.current) {
                featuredImageRef.current.value = '';
            }

            setFeaturedImage(null);
            setSuccessMessage('Blog updated successfully!');
        } catch (err) {
            setError('Failed to update blog');
        }
    }

    return (
        <div className="dashboard update_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Edit Blog</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                
                {blog ? (
                    <div>
                        {/* Language Tabs */}
                        <div className="language-tabs" style={{ marginBottom: '20px' }}>
                            <button 
                                type="button" 
                                className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                                onClick={() => switchLanguage('en')}
                                style={{
                                    padding: '10px 20px',
                                    marginRight: '10px',
                                    backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                                    color: activeLanguage === 'en' ? 'white' : 'black',
                                    border: '1px solid #ddd',
                                    cursor: 'pointer'
                                }}
                            >
                                English
                            </button>
                            <button 
                                type="button" 
                                className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                                onClick={() => switchLanguage('es')}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                                    color: activeLanguage === 'es' ? 'white' : 'black',
                                    border: '1px solid #ddd',
                                    cursor: 'pointer'
                                }}
                            >
                                Spanish
                            </button>
                        </div>

                        <form onSubmit={handleFormSubmit} encType="multipart/form-data">
                            <div className="update_details_wrap">
                                
                                {/* English Content */}
                                {activeLanguage === 'en' && (
                                    <div className="language-content">
                                        <h3>English Content</h3>
                                        
                                        <div className="form-group">
                                            <label>Blog Title (English)</label>
                                            <input
                                                type="text"
                                                value={blog.title}
                                                onChange={(e) => setBlog({ ...blog, title: e.target.value })}
                                            />
                                        </div>

                                        {/* <div className="form-group">
                                            <label>Slug (English)</label>
                                            <input
                                                type="text"
                                                value={blog.slug}
                                                onChange={(e) => setBlog({ ...blog, slug: e.target.value })}
                                                placeholder="url-friendly-slug"
                                            />
                                        </div> */}

                                        <div className="form-group textareaField">
                                            <h2>Description (English)</h2>
                                            <JoditEditor
                                                value={blog.description}
                                                config={config_jodit}
                                                onBlur={(content) => handleMainDescriptionChange(content)}
                                                onChange={(content) => {}}
                                            />
                                        </div>

                                        <div className="add_field textareaField repeaterFields">
                                            <h2><b>Content Sections (English)</b></h2>
                                            {centerContent && centerContent.length > 0 && centerContent.map((field, index) => (
                                                <div key={index} className="singleReapterFieldContent update">
                                                    <div className="add_field">
                                                        <div className="form-group">
                                                            <h3>Section {index + 1} Title</h3>
                                                            <input
                                                                name="title"
                                                                type="text"
                                                                value={field.title}
                                                                placeholder="Section Title"
                                                                onChange={(event) => handleContentTitleChange(index, event)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="add_field">
                                                        <div className="form-group">
                                                            <h3>Section {index + 1} Description</h3>
                                                            <JoditEditor
                                                                value={field.description}
                                                                config={config_jodit}
                                                                onBlur={(content) => handleContentDescriptionChange(index, content)}
                                                                onChange={(content) => {}}
                                                            />
                                                        </div>
                                                    </div>

                                                    <button type="button" onClick={() => removeContentFields(index)}>
                                                        Remove Section
                                                    </button>
                                                </div>
                                            ))}
                                            <button type="button" onClick={addContentFields}>Add More Sections</button>
                                        </div>
                                    </div>
                                )}

                                {/* Spanish Content */}
                                {activeLanguage === 'es' && (
                                    <div className="language-content">
                                        <h3>Spanish Content</h3>
                                        
                                        <div className="form-group">
                                            <label>Blog Title (Spanish)</label>
                                            <input
                                                type="text"
                                                name="title"
                                                value={spanishData.title}
                                                onChange={handleSpanishInputChange}
                                            />
                                        </div>

                                        {/* <div className="form-group">
                                            <label>Slug (Spanish)</label>
                                            <input
                                                type="text"
                                                name="slug"
                                                value={spanishData.slug}
                                                onChange={handleSpanishInputChange}
                                                placeholder="url-amigable-slug"
                                            />
                                        </div> */}

                                        <div className="form-group textareaField">
                                            <h2>Description (Spanish)</h2>
                                            <JoditEditor
                                                value={spanishData.description}
                                                config={config_jodit}
                                                onBlur={(content) => handleSpanishDescriptionChange(content)}
                                                onChange={(content) => {}}
                                            />
                                        </div>

                                        <div className="add_field textareaField repeaterFields">
                                            <h2><b>Content Sections (Spanish)</b></h2>
                                            {spanishCenterContent && spanishCenterContent.length > 0 && spanishCenterContent.map((field, index) => (
                                                <div key={index} className="singleReapterFieldContent update">
                                                    <div className="add_field">
                                                        <div className="form-group">
                                                            <h3>Section {index + 1} Title</h3>
                                                            <input
                                                                name="title"
                                                                type="text"
                                                                value={field.title}
                                                                placeholder="Título de la Sección"
                                                                onChange={(event) => handleSpanishContentTitleChange(index, event)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="add_field">
                                                        <div className="form-group">
                                                            <h3>Section {index + 1} Description</h3>
                                                            <JoditEditor
                                                                value={field.description}
                                                                config={config_jodit}
                                                                onBlur={(content) => handleSpanishContentDescriptionChange(index, content)}
                                                                onChange={(content) => {}}
                                                            />
                                                        </div>
                                                    </div>

                                                    <button type="button" onClick={() => removeSpanishContentFields(index)}>
                                                        Remove Section
                                                    </button>
                                                </div>
                                            ))}
                                            <button type="button" onClick={addSpanishContentFields}>Add More Sections</button>
                                        </div>
                                    </div>
                                )}

                                {/* Shared Image Fields - Always Visible */}
                                <div className="shared-fields">
                                    <div className="form-group">
                                        <div className="detail_banner_wrap">
                                            <div className="detail_img_grid">
                                                <div className="upload_item">
                                                    <label>Featured Image</label>
                                                    <input type="file" onChange={handleFeaturedImageChange} ref={featuredImageRef} />
                                                </div>
                                                <div className="detail_img_grid">
                                                    {blog.featuredImage ? (
                                                        <div className="detail_img_item">
                                                            <div className="banner_img_wrap">
                                                                <img src={`${config.BASE_URL}${blog.featuredImage}`} alt="Featured" />
                                                            </div>
                                                            <button className="remove_btn" type="button" onClick={() => handleRemoveImage(blog.featuredImage)}>Remove</button>
                                                        </div>
                                                    ) : (
                                                        <p>No image available.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="form-group">
                                            <label>Gallery Images</label>
                                            <input type="file" multiple onChange={handleNewImageChange} ref={fileInputRef} />
                                        </div>
                                        <div className="detail_item_inner gallery_inner">
                                            <div className="detail_img_grid">
                                                {blog?.galleryImages && blog.galleryImages.map((image, index) => (
                                                    <div className="detail_image_item" key={index}>
                                                        <div className="detail_img_item galleryImages">
                                                            <img src={`${config.BASE_URL}${image}`} alt={`blog ${index}`} />
                                                        </div>
                                                        <button className="remove_btn" type="button" onClick={() => handleRemoveImage(image)}>Remove</button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="update_btn_wrap">
                                    <button className="update_btn" type="submit">Update Blog</button>
                                </div>
                                
                                {successMessage && <p className="success-message">{successMessage}</p>}
                                {error && <p className="error-message">{error}</p>}
                            </div>
                        </form>
                    </div>
                ) : (
                    <h5>Blog not found!</h5>
                )}
            </div>
        </div>
        // 
    );
}

export default UpdateBlogDetail;